import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBars, faSignOutAlt} from "@fortawesome/free-solid-svg-icons";
import HeadMenu from "./HeadMenu";
import './../css/navbar-dropdown-menu.css';
import ErrorBoundary from "../ErrorBoundary";

export function Navbar(props) {
    return <nav className="navbar navbar-expand-lg">
        <div className="float-left">
            <a data-activates="slide-out" className="button-collapse black-text"><FontAwesomeIcon icon={faBars}/></a>
        </div>
        <div className="collapse navbar-collapse" id="navbarTop">
            <ErrorBoundary>
                <ul style={{minHeight: '3rem', paddingTop: '.4rem'}} className='navbar-nav mr-auto'>
                    <HeadMenu type='main'/>
                </ul>
                <span style={{color: '#fff', margin: '0 1em'}}>
                    {props.mfgId}
                </span>
                <button type="submit" className="btn-logout" onClick={props.clickLogOut}>
                    <FontAwesomeIcon icon={faSignOutAlt}/>
                </button>
            </ErrorBoundary>
        </div>
    </nav>
}

export default Navbar
